import { render, staticRenderFns } from "./NaviLeftComponent.vue?vue&type=template&id=31460288"
import script from "./NaviLeftComponent.vue?vue&type=script&lang=js"
export * from "./NaviLeftComponent.vue?vue&type=script&lang=js"
import style0 from "./NaviLeftComponent.vue?vue&type=style&index=0&id=31460288&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports